import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import dashboardReducer from './dashboardSlice';
import exchangesReducer from './exchangesSlice';
import marketReducer from './marketSlice';
import tradingPairReducer from './tradingPairSlice';
import triggerReducer from './triggerSlice';
import tradeHistoryReducer from './tradeHistorySlice';
import pnlHistoryReducer from './pnlHistorySlice';
import generalConfigReducer from './generalConfigSlice';
import tradingConfigReducer from './tradingConfigSlice';
import walletBalanceReducer from './walletBalanceSlice';
import validationReducer from './validationSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    exchanges: exchangesReducer,
    markets: marketReducer,
    tradingPairs: tradingPairReducer,
    triggers: triggerReducer,
    tradeHistory: tradeHistoryReducer,
    pnlHistory: pnlHistoryReducer,
    generalConfig: generalConfigReducer,
    tradingConfigs: tradingConfigReducer,
    walletBalances: walletBalanceReducer,
    validation: validationReducer,
  },
});